<script setup lang="ts">
import { computed } from 'vue';

import type { ITableColumnsOptions } from '@modules/tables/types';
import VIconButton from '@components/buttons/VIconButton/VIconButton.vue';
import VCard from '@components/card/VCard/VCard.vue';
import { FORMAT_MONTH } from '@modules/core/composables/datetime/constants';
import { TRANSLATION_GROUP_FINANCE } from '@modules/finance/constants';
import { useFinanceListQuery } from '@modules/finance/queries';
import {
  ADMIN_FINANCE_MONTH_LIST_ROUTE_NAME,
  AFFILIATE_FINANCE_MONTH_LIST_ROUTE_NAME,
} from '@modules/finance/submodules/month-report/constants';
import { useCurrentNamespace } from '@modules/permissions/composables';
import VTable from '@modules/tables/components/VTable/VTable.vue';
import { useTableData } from '@modules/tables/composables';

const {
  tableState,
  isLoading,
  isFetching,
  data,
  updateTableState,
  refreshTableData,
} = useTableData(useFinanceListQuery);
const { isAdminNamespace } = useCurrentNamespace();
const columnOptions: ITableColumnsOptions = {
  aasm_state: {
    localization: {
      translationPath: 'admin.partnership_program.bookkeeping.aasm_state.',
    },
  },
  status: {
    localization: {
      translationPath: 'admin.partnership_program.bookkeeping.aasm_state.',
    },
  },
  date_of_payment: {
    dateFormat: FORMAT_MONTH,
    defaultMobilePreview: true,
  },
};

const monthRouteName = computed(() => (isAdminNamespace.value ? ADMIN_FINANCE_MONTH_LIST_ROUTE_NAME : AFFILIATE_FINANCE_MONTH_LIST_ROUTE_NAME));
</script>

<template>
  <VCard v-data-qa-auto-id="'FinanceListPage'" type="table">
    <VTable
      :data="data"
      :state="tableState"
      :loading="isLoading"
      :is-fetching="isFetching"
      :title-t-path="$getTPath(TRANSLATION_GROUP_FINANCE, 'HEADER')"
      :columns-options="columnOptions"
      @state-update="updateTableState"
      @refresh="refreshTableData"
    >
      <template #recordAction="{ listItem }">
        <VIconButton
          icon="pi-eye"
          :to="{
            name: monthRouteName,
            params: {
              date: listItem.date_of_payment,
            },
          }"
        />
      </template>
    </VTable>
  </VCard>
</template>
